import secureLocalStorage from "react-secure-storage";

export const permissionCheck = (key: string): boolean => {
    const storedPermissionsString: any = secureLocalStorage.getItem('user_permissions');
    
    if (!storedPermissionsString) {
        return false;
    }
    
    let all_permissions: any;
    
    try {
        // Try to parse as JSON (could be string or already parsed)
        all_permissions = typeof storedPermissionsString === 'string' 
            ? JSON.parse(storedPermissionsString) 
            : storedPermissionsString;
    } catch (error) {
        console.error('Error parsing permissions:', error);
        return false;
    }

    if (!all_permissions) {
        return false;
    }

    // Check if permissions is an array
    if (Array.isArray(all_permissions)) {
        return all_permissions.includes(key);
    }
    
    // If it's an object, check if the key is present in the object keys
    if (typeof all_permissions === 'object') {
        if (Object.prototype.hasOwnProperty.call(all_permissions, key)) {
            const permissionValue = all_permissions[key];

            if (typeof permissionValue === 'boolean') {
                return permissionValue;
            }

            if (typeof permissionValue === 'number') {
                return permissionValue === 1;
            }

            if (typeof permissionValue === 'string') {
                const normalized = permissionValue.toLowerCase();
                return normalized === 'true' || normalized === '1' || permissionValue === key;
            }

            return Boolean(permissionValue);
        }

        if (Object.values(all_permissions).includes(key)) {
            return true;
        }
    }
    
    return false;
};





